import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DIALOG_TITLES } from '../../../constants';
import { useDialogs, useStatusForm } from '../../../hooks';
import Form from './Form';

const StatusFormDialog = () => {
  const [title, setTitle] = useState(DIALOG_TITLES.status.create);

  const { activeStatus, showStatusFormDialog: showDialog } = useDialogs();

  const { errorMessage, form, handleOpenChange, handleSubmit, isSubmitting } =
    useStatusForm();

  useEffect(() => {
    if (showDialog) {
      setTitle(activeStatus ? DIALOG_TITLES.status.update : DIALOG_TITLES.status.create);
    }
  }, [activeStatus, showDialog]);

  return (
    <Dialog onOpenChange={handleOpenChange} open={showDialog}>
      <DialogContent className="sm:max-w-2xl gap-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <Form
          errorMessage={errorMessage}
          form={form}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default StatusFormDialog;
